import axios from "axios";
import { useSnackbarStore } from "./app/store";

const api = axios.create({
	baseURL: process.env.NODE_ENV == 'development' ? "http://localhost:3000/api" : "/api",
	headers: {
		"Content-Type": "application/json"
	},
	withCredentials: true,
});

api.interceptors.response.use((response) => response, async (error) => {
	const originalRequest = error.config;
	originalRequest._retry = originalRequest._retry ? originalRequest._retry : 0;

	if( error?.response?.status === 401 && !originalRequest.url?.includes('/auth/') ){
		while(originalRequest._retry < 3) {
			originalRequest._retry++;
			try {
				await refreshAccessToken();
				break;
			} catch (refreshError) {
				useSnackbarStore.getState().show("An unknown authentication error has occurred. Please refresh and try again. [" + error?.response?.status + "]", "error");
			}
		}

		if(originalRequest._retry < 3) {
			return api(originalRequest);
		}
	}
	else if (error?.response?.status === 403) {
		window.location.href = '/forbidden';
	}
	else if (error?.response?.status === 400 && error.response?.data?.message) {
		useSnackbarStore.getState().show(error.response?.data?.message, "error");
		return Promise.reject(error.response?.data?.message);
	}
	else {
		useSnackbarStore.getState().show("An unknown error has occurred. Please refresh and try again. [" + error?.response?.status + "]", "error");
	}

	return Promise.reject(error);
});

export const refreshAccessToken = async () => {
	await api.post('/auth/_login/refresh');
};

export default api;